module.exports = __webpack_public_path__ + "static/img/banner.bd210fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FFP/images/banner.png
// module id = r2LF
// module chunks = 0